import React, { Component } from 'react';
// 套用新版 Header
import { NewHeader } from '@trg/tlw-layout/custom-element';

export default class HeaderSwitch extends Component {
  render() {
    return <NewHeader compatibleMode />
  }
}
